if (!customElements.get("read-more")) {
  customElements.define(
    "read-more",
    class ReadMore extends HTMLElement {
      constructor() {
        super();
        this.viewAllButton = this.querySelector("button");
        this.content = this.querySelector('.read-more__content');
        this.isOpen = false;
        this.bindEvents();
        this.setContentHeight();
      }

      bindEvents() {
        this.viewAllButton.addEventListener("click", this.onClick.bind(this));
      }

      getTotalChildrenHeight(parent) {
        let totalHeight = 0;
        const children = parent.children;
        console.log(children)

        for (let i = 0; i < children.length; i++) {
          const child = children[i];
          const childHeight = child.offsetHeight;
          totalHeight += childHeight;
        }

        return totalHeight;
      }

      setContentHeight() {
        this.content.style.setProperty(
          "--content-height",
          `${this.getTotalChildrenHeight(this.content)}px`
        );
        if(this.getTotalChildrenHeight(this.content) < (this.content.offsetHeight + this.viewAllButton.offsetHeight)){
          this.content.classList.add("active");
        }
      }

      onClick(event) {
        event.preventDefault();

        if(this.isOpen) return;

        this.setContentHeight();
        setTimeout(() => {
          this.content.classList.add("active");
        });
      }
    }
  );
}
